import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export function BlogLayout({ testid, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative bg-white text-brand-navy min-h-screen grain" data-testid={testid}>
      <header className="sticky top-0 z-20 bg-white/90 backdrop-blur-xl border-b border-black/5">
        <div className="flex items-center justify-between px-6 sm:px-10 py-4 max-w-4xl mx-auto">
          <Link to="/" className="flex items-center gap-2.5" data-testid="blog-brand-link">
            <Logo className="w-7 h-7" />
            <span className="font-heading font-extrabold tracking-[0.14em] text-base">NOT BY WILL</span>
          </Link>
          <nav className="flex items-center gap-5 text-sm">
            <Link to="/blog" className="text-stone hover:text-brand-navy transition-colors" data-testid="blog-nav-blog">Blog</Link>
            <Link
              to="/"
              data-testid="blog-cta-start"
              className="inline-flex items-center gap-1.5 rounded-full bg-brand-navy text-white px-4 py-2 font-semibold hover:bg-brand-navy/90 transition-colors"
            >
              Start free
            </Link>
          </nav>
        </div>
      </header>

      {children}

      <footer className="border-t border-black/5 px-6 sm:px-10 py-10 bg-white">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <Link to="/" className="flex items-center gap-2.5" data-testid="blog-footer-brand">
            <Logo className="w-6 h-6" />
            <span className="font-heading font-extrabold tracking-[0.14em] text-sm">NOT BY WILL</span>
          </Link>
          <div className="flex flex-wrap items-center gap-5 text-sm">
            <Link to="/blog" className="text-stone hover:text-brand-navy transition-colors">Blog</Link>
            <Link to="/privacy" className="text-stone hover:text-brand-navy transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-stone hover:text-brand-navy transition-colors">Terms of Use</Link>
            <Link to="/" className="flex items-center gap-1.5 text-brand-teal-dark font-medium hover:underline">
              <ArrowLeft className="w-4 h-4" /> Home
            </Link>
          </div>
        </div>
        <p className="max-w-4xl mx-auto text-xs text-stone/70 mt-6 leading-relaxed">
          Not By Will offers faith-based support and encouragement for quitting nicotine. It is not medical advice.
          If you have a health condition or concerns, talk to your doctor. In an emergency, call 911.
        </p>
      </footer>
    </div>
  );
}
